





































import { computed, defineComponent, PropType, ref, toRefs } from '@vue/composition-api';
import TtamTrackingViewabilitySwitch from './switch.vue';
import TtamTrackingViewabilityInput from './input.vue';
import { i18n } from '@tt4b/ttam-i18n';

const name = 'ttam-tracking-viewability';

export default defineComponent({
  name,

  components: { TtamTrackingViewabilitySwitch, TtamTrackingViewabilityInput },

  props: {
    switchValue: { type: Boolean, default: false },
    url: { type: String, default: undefined },
    type: { type: Number, default: undefined },
    rules: { type: Array, default: () => [] },
    title: {
      type: String,
      default: i18n.t('module_track_url_view_title_with_moat'),
    },
    titleHint: { type: String, default: i18n.t('module_track_url_view_hint') },
    switchHint: { type: String, default: '' },
    isIASSelect: { type: Boolean, default: false },
    isOnlyShowViewIAS: { type: Boolean, default: false },
    isOnlyOneViewTrackType: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    options: {
      type: Array as PropType<{ value: string; label: string }[]>,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: i18n.t('module_track_url_ias_placeholder'),
    },
  },

  setup(props, { emit }) {
    const { switchValue } = toRefs(props);

    const formItemRef = ref(null);

    const handleResetField = () => {
      formItemRef.value?.resetField?.();
    };

    const handleEmit = (eventName, value) => {
      handleResetField();
      emit(eventName, value);
    };

    const isSwitchOn = computed({
      get: () => switchValue.value,
      set: val => handleEmit('switch-change', val),
    });

    function onUrlChange(val) {
      handleEmit('url-change', val);
    }

    function onTypeChange(val) {
      handleEmit('type-change', val);
    }

    return {
      name,
      formItemRef,
      isSwitchOn,
      onUrlChange,
      onTypeChange,
    };
  },
});
